var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex items-center justify-center",
      attrs: { "data-component": "base-icon" },
    },
    [
      _vm.useSvg
        ? _c(
            "svg",
            {
              class: _vm.sizeClasses,
              attrs: {
                viewBox: "0 0 32 32",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [_c("use", { attrs: { href: "#" + _vm.icon } })]
          )
        : _c("or-icon", {
            attrs: { icon: _vm.icon, variant: _vm.variant, size: _vm.size },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }